<script>
  import Vue from 'vue';
  import _system from '../../libs/system';
  import _ from 'lodash'
  import { mapGetters, mapActions } from 'vuex'

  import iziToast from 'izitoast'
   import 'izitoast/dist/css/iziToast.min.css';

  import { getPlatformImage } from './mixins/getPlatformImage'
  import { _fetchMethods } from './mixins/_fetch'

  import { Datetime } from 'vue-datetime';
  Vue.component('datetime', Datetime);
  import 'vue-datetime/dist/vue-datetime.css'


  import  popupsAlertsAuth from "./popups/alerts/auth.vue";
  
	export default {
    name: 'InboxFilter',
    props: ['threaded'],
    mixins: [ getPlatformImage, _fetchMethods ],
    components:{ popupsAlertsAuth },
		data() 
        {
        	return {
            isDesktop: false,
            messageCount: '',
            showDeleteIcon: false,
            showUpdateTagIcon: false,
            showUpdateTagIconWrapper: false,
            selectedtagColor: '#dddddd',
            tagSelectedToUpdate: {},
            alertData: {},
            searchTags: '',
            filter: {
              accounts : null,
              status: null,
              isMention: false
            },
            updateCountsOnTemplate: 0,
              assignedConversationNumber: 0,
              active: 0,
              active2: 'All',
              after: '',
              hovered: '99999',
              startDate: '',
              endDate: '',
              currentDate: '',
              babaa: ''
        	}
        },
        computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn', 'getUser', 'getJwt', 'getPreferences']),
          ...mapGetters('htmlModals', ['modals']),
	        ...mapGetters('statuses', ['statuses', 'statusesByName']),
	        ...mapGetters('tags', ['tags', 'getEnumaratedTags', 'tagsByName', 'tagsByTypeName','tagsByName', 'tagsById']),
          ...mapGetters('accounts', ['accounts', 'accountsById', 'accountsByPId', 'workspaceAccountsByPId', 'activeAccounts']),
          ...mapGetters("loading", ["loadingMessages"]),          
	        ...mapGetters('networks', ['networks', 'networksById', 'networksByName']),
          ...mapGetters('mobileMenu', ['rightMobileMenu']),
          ...mapGetters('messages', ['messages','messagesCount']),
          ...mapGetters('workspaces', ['currentWorkspace']),
          ...mapGetters('workspaceusers', ['workspaceusers']),
          ...mapGetters('notifications', ['getNoteNotificationSince','getNotificationMessages', 'getNotificationSince', 'getNotificationMessagesGroupedByPageId']),
          ...mapGetters('inboxFilters', ['getInboxFilters', 'getInboxFiltersPageId', 'getInboxFiltersStatusId']),
          suitableForRatings(){
            let ReviewTypeAccount = _.filter(this.accounts, (account) => {
                    return account.platform === this.networksByName['Google My Business']._id || account.platform === this.networksByName['App Store']._id || account.platform === this.networksByName['Google Play']._id
                  })
                  return ReviewTypeAccount.length
          },
          menu(){
            let menu = [
            {
              title: 'Status',
              type: 'radio',
              data: [{
                name: 'Open',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'notTagId',
                messageCount: this.messagesCount,
                isActive: () => { 
                  return _.includes(this.getInboxFilters.notTags, this.getEnumaratedTags.Archived._id) && 'selected'
                },
                setFilter: () => {
                  if(this.getInboxFilters.notTags.includes(this.getEnumaratedTags.Archived._id)){
                    return this.fetch_messages();
                  }
                  this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== this.getEnumaratedTags.Archived._id);
                  this.getInboxFilters.notTags.push(this.getEnumaratedTags.Archived._id);
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              },{
                name: 'Archived',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'tagId',
                messageCount: this.messageCount,
                isActive: () => {

                  return _.includes(this.getInboxFilters.tags, this.getEnumaratedTags.Archived._id) && 'selected'
                  },
                setFilter: () => {
                  this.getInboxFilters.notTags = _.remove(this.getInboxFilters.notTags, (n)=> n !== this.getEnumaratedTags.Archived._id);
                  this.getInboxFilters.tags.push(this.getEnumaratedTags.Archived._id)
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Order by',
              type: 'radio',
              data: [{
                name: 'Newest to oldest',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'tagId',
                isActive: () => {
/*                   console.log('Newest to oldest')
                  console.log((this.getInboxFilters.reverse == false)) */
                    if(this.getInboxFilters.reverse === false){
                      return 'selected'
                    }
                  },
                setFilter: () => {
                  this.setInboxFiltersReverse(false);
                  return this.fetch_messages();
                }
              },{
                name: 'Oldest to newest',
                val: this.getEnumaratedTags.Archived._id,
                queryParam: 'notTagId',
                isActive: () => { 
/*                   console.log('Oldest to newest')
                  console.log(this.getInboxFilters.reverse)
                  console.log((this.getInboxFilters.reverse === true)) */

                    if(this.getInboxFilters.reverse === true){
                      return 'selected'
                    }

                },
                setFilter: () => {
                  this.setInboxFiltersReverse(true);
                  console.log(this.getInboxFilters.reverse)
                  return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Filtering',
              type: 'select',
              data: [{
                name: 'Assigned To Me',
                queryParam: 'assigneeId',
                icon: 'user circle icon',
                disabled:  false,
                isActive: () => {
                  if(this.getInboxFilters.assignedTo.length && !this.getInboxFilters.assignedTo.includes('!')){
                    return 'checked' 
                  }
                },
                setFilter: () => {
                  if(this.getInboxFilters.assignedTo.length){
                    this.getInboxFilters.assignedTo = [];
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }
                  this.getInboxFilters.assignedTo.push(this.getUser._id)
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              },
              {
                name: 'Unassigned',
                queryParam: 'assigneeId',
                icon: 'user times icon',
                disabled: false,
                isActive: () => {
                  return this.getInboxFilters.assignedTo.includes('!') && 'checked'
                },
                setFilter: () => {
                  if(this.getInboxFilters.assignedTo.length){
                    this.getInboxFilters.assignedTo = []
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }

                  this.getInboxFilters.assignedTo.push('!')
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              }]
            },
            {
              title: 'Channels',
              type: 'select',
              data: () => {
                
                let arr = [];

                arr.push({
                _type: 'All Channels',
                name: 'All Channels',
                queryParam: '',
                icon: 'list alternate outline icon',
                isActive: () => {
                  return !this.getInboxFilters.pageIds.length && 'checked'
                },
                setFilter: () => {
                  this.getInboxFilters.pageIds = []
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              })

              let channels = _.map(this.accounts, (item) => {
                  item._type = 'channel'
                  item.queryParam = 'pageId'

                  
                  //custom by user email
                  if(this.getUser.email.includes('upchannels.com')){
                    item.name = item.name
                  }else{
                    item.name = item.name
                  }

                  item.reAuth = () => {

                    if(item.tags && item.tags.includes(this.tagsByName['Passive']._id) && item.tags.includes('610d429248da7e774801c9e9')){
                      return {
                        id: 'instagram',
                        page: item,
                        active: true,
                        content: 'Instagram needs messages permission to be activated!'
                      }
                    }else if(item.tags && item.tags.includes(this.tagsByName['Passive']._id)){
                       return {
                        id: 'default',
                        page: item,
                        active: true,
                        content: 'Access token nees to be refreshed!'
                      }
                    }

                    //(item.tags && item.tags.indexOf(this.tagsByName['Passive']._id) == -1) ? false : true
                    return {
                      id: '0',
                      active: false,
                      content: ''
                    }
                  }
                  item.setFilter = () => {
                  if(_.includes(this.getInboxFilters.pageIds, item._id)){
                    this.getInboxFilters.pageIds = _.remove(this.getInboxFilters.pageIds, (n)=> n !== item._id);
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                      return this.fetch_messages();
                  }
                    this.getInboxFilters.pageIds.push(item._id)
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                      return this.fetch_messages();
                  }
                   item.isActive =  () => {
                    return _.includes(this.getInboxFilters.pageIds, item._id) && 'checked'
                  }
                  return item
                })

                arr = arr.concat(channels);

                return arr
              }
            },
            {
              title: 'Ratings',
              type: 'radio',
              dataRatings: () => {

                let ratings = _.filter(this.tagsByTypeName['DefaultMessageTag'], (t) => t.name.includes('Star'));

                return _.map(ratings, (item) => {
                  item.queryParam = 'tagId'
                  item.setFilterRatings = () => {

                    console.log(item)
                  
                  //If clicked rating exist then remove it and render
                  if(_.includes(this.getInboxFilters.tags, item._id)){
                    this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== item._id);
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                      return this.fetch_messages();
                  }
 
                  //if another rating is clicked
                    this.getInboxFilters.tags.push(item._id)
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));

                    let unselectedRatings = _.filter(ratings, (i) => i._id !== item._id);
                      unselectedRatings = _.map(unselectedRatings, (e) => e._id)

                      _.map(unselectedRatings, (tag) => {
                        this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== tag);
                      });

                      return this.fetch_messages(+ new Date() - 1000*60*60*24*30);
                  }
                  item.isActiveRatings = () => {
                     return _.includes(this.getInboxFilters.tags, item._id) && 'active'
                  }

                  return item;
                });
               
              }
            },
            {
              title: 'Tags',
              type: 'select',
              data: () => {

                
                let allTags = [];

                if(this.currentWorkspace.userTags && this.currentWorkspace.userTags.length){

                let customTagsClone =  Object.assign({}, this.currentWorkspace.userTags);

                    customTagsClone = _.map(this.currentWorkspace.userTags, (tag) =>{
                                        tag.customTag = true;
                                        return tag
                                      }) 

                  allTags = this.tagsByTypeName['DefaultMessageTag'].concat(customTagsClone);
                }else{
                  allTags = this.tagsByTypeName['DefaultMessageTag']
                }

                 let updatedArray = _.map(allTags, (item) => {
                  item.queryParam = 'tagId'
                  item.color = (item.color && item.color.length) ? item.color : '#d6d6d6';
                  item.setFilter = () => {
                  if(_.includes(this.getInboxFilters.tags, item._id)){
                    this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== item._id);
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                      return this.fetch_messages();
                  }
                    this.getInboxFilters.tags.push(item._id)
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                      return this.fetch_messages();
                  }
                  item.isActive = () => {
                     return _.includes(this.getInboxFilters.tags, item._id) && 'active'
                  }

                  if(item.customTag){
                    item.remove = () => {
                      let payload = {
                        query:{
                          workspaceId: this.currentWorkspace._id,
                          tagId: item._id
                        }
                      }
                      return _system.services.tags.removeTagFromCurrentWorkspace(payload, (err, res) => {
                        if(err) return alert(err.message)

                        return this.currentWorkspace.userTags = res.userTags
                      })
                    }
                  }

                  return item
                })

                //Add Custom Tag
                let commentTagObject = {
                  id: '123ı10djm2ıjd0phj',
                  name: 'Comments',
                  queryParam: 'notTagId',
                  isActive: () => { 
                    return _.includes(this.getInboxFilters.notTags, this.getEnumaratedTags.DirectMessage._id) && 'active'
                  },
                  setFilter: () => {
                    if(_.includes(this.getInboxFilters.notTags, this.getEnumaratedTags.DirectMessage._id)){
                      this.getInboxFilters.notTags = _.remove(this.getInboxFilters.notTags, (n)=> n !== this.getEnumaratedTags.DirectMessage._id);
                      return this.fetch_messages();
                    }
                    this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== this.getEnumaratedTags.DirectMessage._id);
                    this.getInboxFilters.notTags.push(this.getEnumaratedTags.DirectMessage._id);
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }
                }

                updatedArray.unshift(commentTagObject);


                updatedArray = _.map(updatedArray, (item) => {
                  if(item.name == 'Comments' || item.name == 'Ads Comments' || item.name == 'Direct Message'){
                    item.messageType = true;
                  }


                  if([this.getEnumaratedTags.OneStar._id,this.getEnumaratedTags.TwoStar._id,this.getEnumaratedTags.ThreeStar._id,this.getEnumaratedTags.FourStar._id,this.getEnumaratedTags.FiveStar._id].includes(item._id)){
                    item.ratingsMenu = true;
                  }

                  //hide archied 
                  if(item.name == 'Archived'){
                    item.archived = true;
                  }

                  return item
                });
                
                return updatedArray.filter(item => {
                        return item.name.toLowerCase().indexOf(this.searchTags.toLowerCase()) > -1
                      })
              }
            }
          ]

            //Custom Menu
            if(this.getUser.email.includes('designandprintagency.com') || this.getUser.email.includes('juphy2.com')){
              let filtering = _.find(menu, { title: 'Filtering' });
              console.log('f::', filtering);

              //AssignedToMe
              menu[1].data[0] = {
                name: 'Assigned To Me',
                queryParam: 'assigneeId',
                icon: 'user circle icon',
                disabled:  false,
                isActive: () => {
                  if(this.getInboxFilters.assignedTo.length && !this.getInboxFilters.assignedTo.includes('!')){
                    return 'checked' 
                  }
                },
                setFilter: () => {
                  if(this.getInboxFilters.assignedTo.includes(this.getUser._id)){
                    this.getInboxFilters.assignedTo = [];
                    this.getInboxFilters.assignedTo.push('!');
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }

                  if(this.getInboxFilters.assignedTo.includes('!')){
                    this.getInboxFilters.assignedTo = [];
                    this.getInboxFilters.assignedTo.push(this.getUser._id);
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }
                  

                  this.getInboxFilters.assignedTo.push(this.getUser._id);
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              }

/*               setFilter: () => {
                  if(this.getInboxFilters.assignedTo.length){
                    this.getInboxFilters.assignedTo = []
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }

                  this.getInboxFilters.assignedTo.push('!')
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                } */

              //Unassigned
              menu[1].data[1] = {
                name: 'Unassigned',
                queryParam: 'assigneeId',
                icon: 'user times icon',
                disabled: false,
                isActive: () => {
                  return this.getInboxFilters.assignedTo.includes('!') && 'checked'
                },
                setFilter: () => {
                  if(this.getInboxFilters.assignedTo.includes('!')){
                    console.log('Suan ! var')
                    this.getInboxFilters.assignedTo = [];
                    this.getInboxFilters.assignedTo.push(this.getUser._id)
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }

                  if(this.getInboxFilters.assignedTo.includes(this.getUser._id)){
                    console.log('Suan User var')
                    this.getInboxFilters.assignedTo = [];
                    this.getInboxFilters.assignedTo.push('!')
                    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                    return this.fetch_messages();
                  }
                  
                  this.getInboxFilters.assignedTo.push('!')
                  this.setInboxFilters(Object.assign({}, this.getInboxFilters ));
                  return this.fetch_messages();
                }
              }

            }

            return menu
          },
          onlyActiveAccounts(){
            let onlyActivePages = _.filter(this.accounts, (account) => {
              if(account.tags && account.tags.indexOf(this.tagsByName['Passive']._id) == -1 || !account.tags) return account;
            });
            return _.orderBy(onlyActivePages, ['name']);
          }
      },
      methods: {
        ...mapActions("loading", ["setLoadingMessages"]),
        ...mapActions("session", ["setPreferencesNotifications"]),
        ...mapActions('messages', ['setMessages', 'setMessagesCount']),
        ...mapActions('inboxFilters', ['setInboxFilters', 'setInboxFiltersPageIds', 'setInboxFiltersIsMention', 'setInboxFiltersTags', 'setInboxFiltersNotTags', 'setInboxFiltersStatusId','setInboxFiltersSkip', 'setInboxFiltersReverse', 'setInboxFiltersType', 'setInboxFiltersAfter', 'setInboxFiltersBefore', 'setInboxFiltersAssignedToMe', 'setSaveFilters']),
        ...mapActions('statuses', ['setStatuses']),
        ...mapActions('workspaceusers', ['setWorkspaceusers', 'updateWorkspaceusersByIndex']),
        ...mapActions('accounts', ['setAccounts']),
        ...mapActions('notifications', ["setNotificationNotes", "setConcatNotificationNotes", "setNotificationMessages", 'setConcatNotificationMessages', 'setNotificationSince', 'setNotificationMessagesGroupedByPageId']),
        ...mapActions('mobileMenu', ['toggleRightMenu']),
        ...mapActions("htmlModals", ["setCreateTag", "setOnboardingInbox", "setCreateSearchModal", "setAutomationRulesModal", "setConnectionError"]),

        seto(name){
          this.babaa = name
        },
        selectInput(){},
        selectInput(){},

        updateFilter(data, type){
          
          switch(type) {
            case 'Open':
              
              break;
            case y:
              // code block
              break;
            default:
              // code block
          } 

        },


    updateAssigned(){

      if(this.getInboxFilters.assignedTo.length) {

        this.setInboxFiltersAssignedToMe([]);

      }else{

        this.setInboxFiltersAssignedToMe([this.getUser._id]);

      } 

      this.fetch_messages();

    },  
    updateAccounts(account){

          if(!account){
            this.setInboxFiltersType('all')
            this.setInboxFiltersPageIds([]);
            this.setNotificationMessages([]);
            this.setNotificationMessagesGroupedByPageId([]);
            this.fetch_messages();
            this.setNotificationSince(+ new Date());
            return
          }

          this.setInboxFiltersType('page')
          var index = this.getInboxFilters.pageIds.indexOf(account._id);

          if(index > -1) {

              this.getInboxFilters.pageIds.splice(index, 1);

          }else{

              this.getInboxFilters.pageIds.push(account._id);

          }

          this.setInboxFiltersPageIds(this.getInboxFilters.pageIds);
      
          //this.setInboxFiltersPageIds(account._id);
          
          this.fetch_messages();

          //setNotifications
          let removedNewNotificationMessages = _.filter(this.getNotificationMessages, (notificationMessage) => notificationMessage.page != this.getInboxFilters.pageId)

          this.setNotificationMessages(removedNewNotificationMessages);

          this.setNotificationMessagesGroupedByPageId(removedNewNotificationMessages);

          this.setNotificationSince(+ new Date());

        },
      updateTime(){

        setTimeout( () => {
            this.setInboxFiltersAfter(new Date(this.startDate).getTime())
            this.setInboxFiltersBefore(new Date(this.endDate).getTime())
            this.fetch_messages(new Date(this.startDate).getTime());
        }, 500)
      },
      updateTagColorModal(tag){

        this.showUpdateTagIconWrapper = true;

        this.tagSelectedToUpdate = tag;

        setTimeout(()=>{
          var pickColor = document.querySelector('#pickColor');

            var picker = new window.Picker({
            parent: pickColor,
            color: 'rgb(221, 221, 221)',
            popup: 'left',
            editorFormat: 'hex'
            });

            // You can do what you want with the chosen color using two callbacks: onChange and onDone.
            picker.onChange = (color) => {
              this.selectedtagColor = color.hex;
            };
        }, 500)

      },
      updateTagColor(tag){

        let payload = {
          body: {
            color: this.selectedtagColor
          },
          query: {
            workspaceId: this.currentWorkspace._id,
            tagId: this.tagSelectedToUpdate._id
          }
        }

        _system.services.workspaces.updateTagColor(payload,(err, newWorkspace) => {
               if(err) return alert('Plese, Try again later!');


               let i = _.findIndex(this.currentWorkspace.userTags, {_id:this.tagSelectedToUpdate._id })

               if(i !== -1 ){
                this.currentWorkspace.userTags[i].color = this.selectedtagColor;
                this.$set(this.currentWorkspace.userTags, i,  this.currentWorkspace.userTags[i]);
               }


               iziToast.success({
                  title: 'Tag Updated'
              });

              this.showUpdateTagIconWrapper = false;

        });
        //document.querySelector('#pickColor').click();

      },
    updateTags(tag, checker){

          var index = this.getInboxFilters.tags.indexOf(tag._id);

          if(index != -1) {

              this.getInboxFilters.tags.splice(index, 1);

          }else{

              this.getInboxFilters.tags.push(tag._id);

          }

          if(checker === null){
            this.getInboxFilters.tags.splice(index, 1);
          }

          this.setInboxFiltersTags(this.getInboxFilters.tags);

          if(this.isActive(null, 'open')){
              var index = this.getInboxFilters.tags.indexOf(this.getEnumaratedTags.Archived._id);
              if(index !== -1) {
              this.getInboxFilters.tags.splice(index, 1);
              }
              this.setInboxFiltersNotTags([this.getEnumaratedTags.Archived._id]);
          }else{
              this.setInboxFiltersNotTags([]);
          }


          this.fetch_messages();

        },
    updateNotTags(type){

      if(type == 'open'){
          var index = this.getInboxFilters.tags.indexOf(this.getEnumaratedTags.Archived._id);

          if(index !== -1) {
              this.getInboxFilters.tags.splice(index, 1);
          }

          this.setInboxFiltersNotTags([this.getEnumaratedTags.Archived._id]);
          this.setInboxFiltersTags(this.getInboxFilters.tags);

          this.fetch_messages();
      }

      if(type == 'unread'){
      /* this.setInboxFiltersNotTags([this.getEnumaratedTags.Read._id]) */

          var index = this.getInboxFilters.tags.indexOf(this.getEnumaratedTags.Read._id);

          if(index !== -1) {
              this.getInboxFilters.tags.splice(index, 1);
          }


   
          this.setInboxFiltersNotTags([this.getEnumaratedTags.Read._id]);
          this.setInboxFiltersTags(this.getInboxFilters.tags);

          //console.log(this.getInboxFilters.notTags)

          this.fetch_messages();
      }

        },
        ratingCalculator(tag){
      let rating = 1;
      if(tag.includes(this.getEnumaratedTags.OneStar._id)){
        rating = 1;
      }

      if(tag.includes(this.getEnumaratedTags.TwoStar._id)){
        rating = 2;
      }

      if(tag.includes(this.getEnumaratedTags.ThreeStar._id)){
        rating = 3;
      }

      if(tag.includes(this.getEnumaratedTags.FourStar._id)){
        rating = 4;
      }

      if(tag.includes(this.getEnumaratedTags.FiveStar._id)){
        rating = 5;
      }
      
      let array1 = [];
      let i;
      for(i = 0; i < 5; i++){
        let obj = {};
        obj.id = i;
        if(i < rating){
          obj.rated = 'orange'
        }else{
          obj.rated = ''
        }
        array1.push(obj)
      }

      return array1;

    },
        isActive(_id, type){

          if(type == 'Channels'){
            if(_.find(this.getInboxFilters.pageIds, (id) => id == _id)) {
              return true
            }else{
              return false
            }
          }

          if(type == 'All'){
            if(this.getInboxFilters.pageIds && this.getInboxFilters.pageIds.length) {
              return false
            }else{
              return true
            }
          }

          if(type == 'Assigned'){
            if(this.getInboxFilters.assignedTo && this.getInboxFilters.assignedTo.length) {
              return true
            }else{
              return false
            }
          }

          if(type == 'Tags'){
            let isTagExist = _.find(this.getInboxFilters.tags, (tagId) => tagId === _id);
            if(this.getInboxFilters.tags && isTagExist) {
              return true
            }else{
              return false
            }
          }

          if(type == 'readStatusAll'){
            let readTag = _.find(this.getInboxFilters.tags, (tagId) => tagId === this.getEnumaratedTags.Read._id);
            if(!this.getInboxFilters.notTags && !readTag || this.getInboxFilters.notTags && !this.getInboxFilters.notTags.length && !readTag ) {
              return true
            }else{
              return false
            }
          }
          

          if(type == 'readStatusRead'){
            let readTag = _.find(this.getInboxFilters.tags, (tagId) => tagId === this.getEnumaratedTags.Read._id);
            if(!this.getInboxFilters.notTags && readTag || this.getInboxFilters.notTags && !this.getInboxFilters.notTags.length && readTag ) {
              return true
            }else{
              return false
            }
          }


          if(type == 'readStatusUnread'){
            if(this.getInboxFilters.notTags && this.getInboxFilters.notTags.length) {
              return true
            }else{
              return false
            }
          }

          if(type == 'open'){
            let archivedTag = _.find(this.getInboxFilters.tags, (tagId) => tagId === this.getEnumaratedTags.Archived._id);
            if(!archivedTag) {
              return true
            }else{
              return false
            }
          }

          if(type == 'archived'){
            let archivedTag = _.find(this.getInboxFilters.tags, (tagId) => tagId === this.getEnumaratedTags.Archived._id);
            if(!this.getInboxFilters.notTags && archivedTag || this.getInboxFilters.notTags && !this.getInboxFilters.notTags.length && archivedTag) {
              return true
            }else{
              return false
            }
          }

        },
        setPref(){
          if(this.getPreferences.notifications){
            this.setPreferencesNotifications(false)
          }else{
            this.setPreferencesNotifications(true)
          }
        },
        openComponent(data){

          document.getElementsByClassName('topBar')[0].style.position = "static";

          this.alertData = data;
          this.setConnectionError(true);
        },
      },
      mounted(){
      this.messageCount = this.messagesCount

        if(document.getElementsByClassName('reAuth').length){
          window.reAuthAlert = setInterval(() => {
            $('.reAuth').transition('flash');
          }, 3000)
        }

/*           tippy('.reAuth', {
            content: 'Permissions Expired! Please contact us to solve problem.',
            animation: 'shift-away'
          }) */

/*           let defaultContent = `<div class="ui basic segment">
          Please, go to channels section and reAuthenticate your cahnnels in order to refresh your permissions!
          </div>`

          let instagramContent = `<div class="ui basic segment">
          <img style="width: 450px;" src="https://juphy.com/wp-content/uploads/2022/07/1632743995315-ig-settings.png">
          <p>It seems like this channel Instagram settings is inactive for dierct message usage. Please follow the steps in the image above and reAuthenticate your channels. Otherwise, you'll not receive direct messages for this page.</p>
          </div>`

          tippy('.reAuth-instagram', {
            content: instagramContent,
            animation: 'shift-away',
            allowHTML: true
          })

          tippy('.reAuth-default', {
            content: defaultContent,
            animation: 'shift-away',
            allowHTML: true
          }) */

        this.isDesktop = window.juphyDesktopApp;

          //Load Notes & Assigned Ones
/*           let payload = {
            query: {
              workspaceId: this.currentWorkspace._id
            }
          }

          if(this.getNoteNotificationSince.length) payload.query.after = this.getNoteNotificationSince

          _system.services.notifications.get(payload, (err, notifications) => {
            if(err) return alert(err.message);


            let updatedNotifications = _.map(notifications, (notification) => {

              let object = {};
              object.user = {}

              if(notification.request.action === '/api/v1/messages/:id/users'){
                object.type = 'assign'
              }else{
                object.type = 'note'
                object.text = notification.request.data.text
              }
              object.messageId = notification.request.params.id
              object.user.email = notification.user.email
              object.user._id = notification.user._id
              object.receivedAt = new Date().getTime(); //Burası geçici olarak eklend, serverdan createdAt gelmesi gerekiyor.

              return object
            });

            this.setConcatNotificationNotes(updatedNotifications);

          }); */

        io.on('disconnect', () => {
            // Do stuff (probably some jQuery)
            console.log('disconnected');
        });

        io.on('messages', (data) => { 

          console.log(data);

          if(typeof data == 'string') return

          //New Message Received
          if(data.operationType && data.operationType == 'insert' && data.fullDocument && !data.fullDocument.replier){
            //let newMessages = _system.services.messages.helper([data.message]);
           //console.log(data.fullDocument);

            let foundedChannel = _.some(this.onlyActiveAccounts, {_id: data.fullDocument.page})
            if(!foundedChannel) return;
           //let pageExist = 
              this.setConcatNotificationMessages([data]);
              this.setNotificationMessagesGroupedByPageId();

            if(Notification.permission == 'granted'){
              var notification = new Notification(data.fullDocument.text);
            }

              if(window.juphyDesktopApp && this.getPreferences.notifications){
        
                let object = {
                  platformName: this.networksById[data.fullDocument.platform].name,
                  pageName: this.accountsById[data.fullDocument.page].name,
                  text: (data.fullDocument.text && data.fullDocument.text.length > 0) ? data.fullDocument.text : ''
                }

                window.ipcRenderer.send('ping', object);
              }

                //var notification = new Notification("1 New Message");
              
          }

          //conversationModal açıksa notification gonderme;
          //New Note Sent By Someone or Message Assigned To Someone
          if((data.updateDescription && data.updateDescription.updatedFields.notes && data.updateDescription.updatedFields.notes.length) || (data.updateDescription && data.updateDescription.updatedFields.users && data.updateDescription.updatedFields.users.length)){

              let notes = [];
              let users = [];

              let object = {};
              object.user = {}

              if(data.updateDescription && data.updateDescription.updatedFields.users && data.updateDescription.updatedFields.users.length){

                users = data.updateDescription.updatedFields.users;

                if(this.getUser._id == users[users.length - 1].assignedBy._id) return console.log('Passsed By Assign');

                object.type = 'assign'
                object.messageId = data.documentKey._id;
                object.user.email = users[users.length - 1].assignedBy.email;
                object.user._id = users[users.length - 1].assignedBy._id;
                object.receivedAt = new Date().getTime();

              }else{

                notes = data.updateDescription.updatedFields.notes;

                //baskası eklendiginde bak
                if(this.getUser._id === notes[notes.length - 1].user._id) return console.log('Passsed By Note');

                object.type = 'note'
                object._id = notes[notes.length - 1]._id;
                object.createdAt = notes[notes.length - 1].createdAt;
                object.messageId = data.documentKey._id;
                object.text = notes[notes.length - 1].text;
                object.user.name = notes[notes.length - 1].user.name;
                object.user.email = notes[notes.length - 1].user.email;
                object.user._id = notes[notes.length - 1].user._id;
                object.receivedAt = new Date().getTime();
              }

            this.setConcatNotificationNotes([object]);
          }

          let newSince
          if(this.getNotificationMessages.length) {
            //newSince = this.getNotificationMessages[0].conversation.lastMessageCreatedAt + 1;
            newSince = +new Date();
            this.setNotificationSince(newSince);
          }
        });
        },
    created(){

      let currentSec = + new Date();

      let currentSecMinus30Days = currentSec - 1000*60*60*24*7;


      let lowdateRangeFasterUsers = [
        'misrpharmacies.com',
        'wise.com'
      ]
      //custom date for users
      if(_.some(lowdateRangeFasterUsers, (e) => this.getUser.email.includes(e))){
        currentSecMinus30Days = currentSec - 1000*60*60*24*2;
      }

      //custom date for wise
      if(this.getUser.email.includes('wise.com')){
        currentSecMinus30Days = currentSec - 1000*60*60*12*1;
      }

      //custom date for mypatricia
      if(this.getUser.email.includes('mypatricia')){
        currentSecMinus30Days = currentSec - 1000*60*60*10*1;
      }

      this.startDate = new Date( currentSecMinus30Days ).toISOString()
      this.endDate = new Date( currentSec + 86400000 ).toISOString()

      this.currentDate = new Date( currentSec + 86400000 ).toISOString()

      this.setInboxFiltersAfter(currentSecMinus30Days)
      this.setInboxFiltersBefore(currentSec + 86400000)
      this.setInboxFiltersType('all');
      this.setNotificationSince(currentSec);
      if(!this.getInboxFilters.tags) this.getInboxFilters.tags = [];
      this.setInboxFiltersNotTags([this.getEnumaratedTags.Archived._id]);
      this.setInboxFiltersTags(this.getInboxFilters.tags);

      //Custom Filtering
      if(this.getUser.email.includes('designandprintagency.com') || this.getUser.email.includes('juphy2.com')){
        this.getInboxFilters.assignedTo = [];
        this.getInboxFilters.assignedTo.push('!');
      }
      

      this.fetch_messages();

      this.active2 = 'All'
      },
      destroyed(){
        io.off('messages')
            
        clearInterval(window.reAuthAlert)
      
      }
	}
</script>

<template>  
  
<div style="margin-bottom: -1rem; background: #f3f3f3; position:relative; z-index: 1; "  v-bind:class="(rightMobileMenu) ? 'ui sidebar right visible' : 'four wide  computer tablet only column' ">

<div v-if="showUpdateTagIconWrapper" style="position: absolute; width: 300px; left: -120%; top: 40%; z-index: 99999;">

  <div style="padding: 0;" @click="showUpdateTagIconWrapper = false"  class="ui basic segment right aligned">
            <a style="background: rgba(0,0,0,0.6); position:relative; z-index:999999" class="ui black mini button">Close</a>
          </div>

  <div class="ui raised segment">
    <div style="margin: -1rem; background: #f5f5f5;" class="ui basic segment">
      <div id="pickColor" style="background: linear-gradient(90deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%); color: rgba(0,0,0,0.5)" class="ui fluid button">Select Color</div>
    </div>
    <div class="ui basic segment">
      <h5>Preview</h5>
      <div class="ui label" :style="{'background': selectedtagColor}">{{ tagSelectedToUpdate.name }}</div>
    </div>
    <div @click="updateTagColor(tagSelectedToUpdate)" class="ui teal fluid button">Update</div>
  </div>
</div>

<popupsAlertsAuth v-if="modals.connectionError" :data="alertData"></popupsAlertsAuth>

  <div style="margin: -1rem; z-index: 99; background: rgb(238, 238, 238, 0.95) none repeat scroll 0% 0%; text-align: left;" class="ui basic segment">
    <button href="#" style="background: transparent;" class="ui circular icon button" @click="setCreateSearchModal(true)" :disabled="loadingMessages"><i style="color: rgba(238, 238, 238, 0.95);" class="search icon"></i></button>
    <button v-if="isDesktop && getPreferences.notifications" @click="setPref()"  data-tooltip="Mute desktop notifications 🤫" data-inverted="" data-position="bottom right" style="background: transparent;" class="ui icon circular button"><i class="bell icon"></i></button>
    <button v-if="isDesktop && !getPreferences.notifications" @click="setPref()" data-tooltip="Turn on ⚡️" data-inverted="" data-position="bottom right" style="background: transparent;" class="ui icon circular button"><i class="bell slash icon"></i></button>
  </div>

<div class="inbox" style="position: absolute; left:0; top:0; bottom: 0; right:0; overflow-x: hidden; height: 100vh; min-height: 100%;">

<div style="height: 46px;"></div>  

<div v-if="rightMobileMenu" style="background:#3150BA; padding: 0;" class="ui basic segment">
  <div  class="ui huge icon inverted menu">
    <a @click="toggleRightMenu(false)" class="item">
        <i class="right arrow icon"></i>
    </a>
  </div>
</div>


<div class="ui basic segment">

  <div v-for="group in menu" :key="group.title">
     <div v-if="group.type == 'radio' && group.title == 'Status'" class="radioButtonGroup">
      <h5 class="ui header filtering">{{ group.title }}</h5>
      <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" class="radioButtonInput">
        <div :class="item.isActive(item)" class="radioButton">
          <div class="selectedDot"></div>
        </div>
        <div class="radioButtonLabel">{{item.name}}</div>
        <div v-if="item.isActive(item) && item.messageCount !== 'undefined' && item.messageCount" style="margin-left: 2px; float:right; background: #ddd; color: black;" class="ui mini circular label">{{ item.messageCount }}</div>
      </div>
    </div>


     <div v-if="group.type == 'radio' && group.title == 'Order by' && getUser.email.includes('wise')" class="radioButtonGroup">
      <h5 class="ui header filtering">{{ group.title }}</h5>
      <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" class="radioButtonInput">
        <div :class="item.isActive(item)" class="radioButton" name="Radiobutton">
          <div class="selectedDot"></div>
        </div>
        <div class="radioButtonLabel">{{item.name}}</div>
      </div>
     </div>

    <div v-if="group.type == 'select' && group.title == 'Filtering'">
      <h5 class="ui header filtering">{{ group.title }}</h5>
      <div v-for="item in group.data" :key="item.name" @click="item.setFilter()" style="position: relative;" class="checkboxInput">
        <div v-if="item.disabled" style="top: 0; left: 0; right: 0; bottom: 0; position: absolute; z-index: 999999999; background: rgba(238, 238, 238, 0.95);"></div>
        <div :class="item.isActive()" class="checkbox">
          <i class="icon-check check icon"></i>
        </div>
        <div style="position: relative;" class="checkboxLabel">
            <span style="display: inline-block;"><i :class="item.icon"></i> {{item.name}}</span>
            <div v-if="getNotificationMessages.length && item.queryParam !== 'assigneeId'" style="margin-left: 5px; float:right; background: #CB4F4A; color: #fbfbfb;" class="ui mini circular label">{{getNotificationMessages.length}}</div>
          </div>
      </div>
    </div>

    <div v-if="group.type == 'select' && group.title == 'Channels'">
      <h5 class="ui header filtering">{{ group.title }}</h5>
      <div v-for="item in group.data()"  :key="item._id" >
        <div @click="item.setFilter()" class="checkboxInput">
        <div :class="item.isActive()" class="checkbox">
          <i class="icon-check check icon"></i>
        </div>
          <div style="position: relative;" class="checkboxLabel">

            <span v-if="item._type == 'All Channels'" style="display: inline-block;"><i :class="item.icon"></i> {{item.name}}</span>
            <div v-if="item._type == 'All Channels' && getNotificationMessages.length && item.queryParam !== 'assigneeId'" style="margin-left: 5px; float:right; background: #CB4F4A; color: #fbfbfb;" class="ui mini circular label">{{getNotificationMessages.length}}</div>

          <img v-if="item._type == 'channel'" style="margin-right: 4px; width: 24px; border-radius: 7px; vertical-align: middle;" :src="item.avatar"> 
            <img v-if="item._type == 'channel'" :src="getPlatformImage(item.platform)" style="bottom: -5.5px;width: 16px;height: 16px;border-radius: 20px;vertical-align: middle;position: absolute;left: -5.5px;border: 1px solid #fff;" alt="">
            <span v-if="item._type == 'channel'" style="display: inline-block;">{{item.name}} <span style="display: none;">{{ item._id }}</span> </span>
            <span v-if="item._type == 'channel' && item.reAuth().active" @mouseover="openComponent(item.reAuth())" :class="'reAuth reAuth-'+ item.reAuth().id" style="font-size: 17px;" >⚠️</span>
            <div v-if="item._type == 'channel' && getNotificationMessagesGroupedByPageId[item._id]" style="margin-left: 5px; float:right; background: #CB4F4A; color: #fbfbfb;" class="ui mini circular label">{{getNotificationMessagesGroupedByPageId[item._id].length}}</div>
          </div>
        </div>
      </div>


     <div class="ui vertical fluid inverted menu">
        <router-link to="/accounts" style="padding: 1rem;font-size: 12px; color: #aaa;" class="icon item">
          <span>Add More Channels</span>
          <i class="long arrow alternate right icon"></i>
        </router-link>
      </div>
    </div>
    
    <div v-if="group.type == 'select' && group.title == 'Tags'">
      <h5 class="ui header filtering">Message Types</h5>
        <div v-for="item in group.data()" :key="item._id" class="ui label inboxFilter"  v-on:click.stop="item.setFilter()" :class="item.isActive()" style="margin-bottom: 5px; cursor:pointer;" v-show="item.messageType" >
            <input v-if="item.isActive()" style="margin-right:4px;" type="checkbox" :checked="item.isActive()">
                {{item.name}}
            <i v-if="item.remove && showDeleteIcon"  v-on:click.stop="item.remove()" class="delete icon"></i>
        </div>
    </div> 
    
    <div v-if="group.type == 'radio' && group.title == 'Ratings'">
      <h5 class="ui header filtering">{{ group.title }}</h5>
      <div v-for="item in group.dataRatings()" :key="item._id" class="ui label inboxFilter"  v-on:click.stop="item.setFilterRatings()" :class="item.isActiveRatings()" style="margin-bottom: 5px; cursor:pointer;" v-show="item.ratingsMenu" >
            <input v-if="item.isActiveRatings()" style="margin-right:4px;" type="checkbox" :checked="item.isActiveRatings()">
            <span v-if="item.ratingsMenu">
              <i v-for="star in ratingCalculator(item._id)" :key="star.id" :class="'ui small fitted '+ star.rated +' star icon'"></i>
            </span>
        </div>
    </div> 
    
<!--     <div v-if="group.type == 'radio' && group.title == 'Tags' && suitableForRatings">
      <h5 class="ui header filtering">Ratings</h5>
        <div v-for="item in group.data()" :key="item._id" class="ui label inboxFilter"  v-on:click.stop="item.setFilter()" :class="item.isActive()" style="margin-bottom: 5px; cursor:pointer;" v-show="item.ratingsMenu" >
            <input v-if="item.isActive()" style="margin-right:4px;" type="checkbox" :checked="item.isActive()">
            <span v-if="item.ratingsMenu">
              <i v-for="star in ratingCalculator(item._id)" :key="star.id" :class="'ui small fitted '+ star.rated +' star icon'"></i>
            </span>
        </div>
    </div>  -->


    <div v-if="group.type == 'select' && group.title == 'Tags'">
      <h5 class="ui header filtering">{{ group.title }} 
        -
        <span @click="setCreateTag(true)" style="cursor: pointer; color: #5f7ec8; font-weight: 400; font-style: italic; text-decoration: underline; font-size: 12px;"> Create New</span> - 
        <span @click="(showUpdateTagIcon) ? showUpdateTagIcon = false : showUpdateTagIcon = true" style="cursor: pointer; color: #5f7ec8; font-weight: 400; font-style: italic; text-decoration: underline; font-size: 12px;"> Update </span> -
        <span @click="(showDeleteIcon) ? showDeleteIcon = false : showDeleteIcon = true" style="cursor: pointer; color: #5f7ec8; font-weight: 400; font-style: italic; text-decoration: underline; font-size: 12px;"> Delete </span>

      </h5>


      <div style="margin-bottom: 1rem;" class="ui mini fluid input">
        <input style="border: none;" v-model="searchTags" type="text" placeholder="Search...">
      </div>
     

        <div v-for="item in group.data()" :key="item._id" class="ui label inboxFilter"  v-on:click.stop="item.setFilter()" :class="item.isActive()" style="margin-bottom: 5px; cursor:pointer;" :style="{'background': item.color}" v-show="!item.messageType && !item.archived && !item.ratingsMenu" >
            <input v-if="item.isActive()" style="margin-right:4px;" type="checkbox" :checked="item.isActive()">
                {{item.name}}
            <i v-if="item.remove && showDeleteIcon"  v-on:click.stop="item.remove()" class="delete icon"></i>

          <div v-if="item.customTag && showUpdateTagIcon" style="margin-left: 3px;"  v-on:click.stop="updateTagColorModal(item)"  class="ui mini black label">update</div>
        </div>
    </div> 

  </div>

</div>

<div style="padding-top: 0;" class="ui basic segment">  
<!--     <div class="ui form">
    <div  style="margin: 0.5rem 0 1rem">

        <h5 class="ui header filtering">Tags <span @click="setCreateTag(true)" style="cursor: pointer; color: #5f7ec8; font-weight: 400; font-style: italic; text-decoration: underline; font-size: 12px;"> Create New</span></h5>
  

    </div>
    <div class="field" style="margin-bottom: 6px;">
       <div v-for="tag in tagsByTypeName['DefaultMessageTag']" :key="tag._id" style="margin-bottom: 5px; cursor:pointer;" :class="(isActive(tag._id, 'Tags')) ? 'active' : '' "  @click="updateTags(tag)" class="ui label inboxFilter">
         <input v-if="isActive(tag._id, 'Tags')" style="margin-right:4px;" type="checkbox" :checked="isActive(tag._id, 'Tags')">
              {{tag.name}}
        </div>  
      <div v-for="tag in currentWorkspace.userTags" :key="tag.name"  @click="updateTags(tag)" style="background: #dcdcdc; margin-bottom: 5px; cursor:pointer;" :class="(isActive(tag._id, 'Tags')) ? 'active' : '' "  class="ui gray label inboxFilter">
        <input v-if="isActive(tag._id, 'Tags')" style="margin-right:4px;" type="checkbox" :checked="isActive(tag._id, 'Tags')">
         {{tag.name}}
        </div>
    </div>
  </div> -->
  <div class="ui hidden divider"></div>   


<div class="ui form">
  <h5 class="ui header filtering">Date</h5>
  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">FROM :</span>
    <datetime style="position:relative;" :max-datetime="currentDate" v-model="startDate" :type="'datetime'" input-id="startDate">
      <i style="position: absolute;right: 6px;top: 10px; color: #ddd; z-index:1;" for="startDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
        <span style="display: block; padding: 5px 9px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    
    </datetime>
    <div style="height:10px;"></div>
  <span style="display: inline-block; background: #e5e5e5; color: #aaa; font-size: 10px; padding: 0px 5px; border-radius: 3px 3px 0 0; font-weight: bold; margin-bottom: -2px;">TO :</span>
    <datetime style="position:relative;" :min-datetime="startDate" :max-datetime="currentDate" v-model="endDate" :type="'datetime'"  input-id="endDate">
      <i style="position: absolute;right: 6px;top: 9px; color: #ddd; z-index:1;" for="endDate" slot="before" class="calendar alternate outline icon"></i>
        <template slot="button-confirm" slot-scope="scope" >
          <span style="display: block; padding: 5px 10px; background: #f1f1f1;" @click="updateTime()">Update</span>
        </template>
    </datetime>
  </div>  

    <div class="ui hidden divider"></div>   
    <div style="border: 1px solid #eee; margin-top: 15px; margin-bottom: 10px;"></div>
</div>
</div>
</div>
</template>


<style scoped>

/deep/ .vdatetime-popup__actions__button {
    padding: 0px 0px !important;
}

/deep/ .vdatetime-input{
  border: 2px solid #e5e5e5 !important;
  border-radius: 0 5px 5px 5px !important;
}
/deep/ .vdatetime-input:hover{
  cursor: pointer;
  background: #f1f1f1;
}

h5.ui.header.filtering{
  margin-top:1rem;
}

.inbox {
    overflow-y: scroll;
}
.inbox:hover {
    overflow-y: scroll;
    overflow-y: overlay;
}

.radioButtonGroup {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
     flex-direction: column; 
    -webkit-box-align: start;
    align-items: flex-start;
}

.radioButtonInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.radioButtonGroup .radioButtonInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonInput {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
}

.radioButtonGroup .radioButtonInput .radioButton.selected {
    border: 2px solid #3960BD;
}

.radioButtonGroup .radioButtonInput .radioButton {
    position: relative;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    cursor: pointer;
    border-radius: 18px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    }

    .radioButtonGroup .radioButtonInput .radioButtonLabel {
    cursor: pointer;
    padding: 0 10px;
    font-size: 14px;
    line-height: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radioButtonGroup .radioButtonInput .radioButton.selected .selectedDot {
    background: #3960BD;
    opacity: .8;
}

.radioButtonGroup .radioButtonInput .radioButton .selectedDot {
    width: 7px;
    height: 7px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #aaa;
    opacity: 0;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    transform: translate(-50%, -50%);
    border-radius: 7px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.radioButtonGroup .radioButtonInput:hover .radioButton.selected .selectedDot {
    opacity: .8;
}

.radioButtonGroup .radioButtonInput:hover .radioButton .selectedDot {
    opacity: .3;
}

.checkboxInput {
    margin: 0 0 10px;
    cursor: pointer;
}

.checkboxInput {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
}

.checkboxInput .checkbox {
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-width: 16px;
    width: 18px;
    height: 18px;
    border: 2px solid #ddd;
    border-radius: 5px;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    position:relative;
}

.checkboxInput .checkbox .icon-check {
    font-size: 10px;
    color: #aaa;
    opacity: 0;
    -webkit-transition: all .1s ease-in-out;
    transition: all .1s ease-in-out;
    -webkit-transform: translate(18%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    bottom: 25%;
    height: 12px;
    top: 25%;
}
.checkboxInput .checkboxLabel {
  position: relative;
    margin: 0 10px;
    font-size: 14px;
    line-height: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    height: 22px;
}

.checkboxInput:hover .checkbox .icon-check {
    opacity: .3;
}

.checkboxInput .checkbox.checked .icon-check {
    color: #3960BD;
    opacity: 1;
}

.checkboxInput .checkbox.checked {
    border-color: #3960BD;
}

.filterItem {
  border: 1px solid #f1f1f1;
  background: #f6f6f6;
  border-radius: 3px;
  transition: .3s;
}
/* .filterItem:hover {
  background: #f9f9f9; 
  border: 1px solid #e9e9e9;
  border-radius: 3px;
  transition: .1s;
} */
.filterItem:hover {
  background: #f2f6ff; 
  border: 1px solid #3960bd4d;
  border-radius: 3px;
  transition: .1s;
}
.filterItem.active {
  background: #f2f6ff; 
  border: 1px solid #3960bd4d;
  border-radius: 3px;
}
.ui.label.inboxFilter{
      border: 1px solid transparent !important;
}
.ui.label.inboxFilter:hover{
      background: #f2f6ff !important; 
      border: 1px solid #3960bd4d !important;
      color: #444444 !important;
}
.ui.label.inboxFilter.active{
      background: #f2f6ff !important; 
      border: 1px solid #3960bd4d !important;
      color: #444444 !important;
}


#startDate:hover {
    color: #111; 
}
#endDate:hover {
    color: #111; 
}

#startDate{
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  border: none;
  background: #f9f9f9;
  color: #777;
  position:relative;
  font-style: italic;
}
#endDate{
  border-left: none;
  border-bottom: none;
  border-right: none;
  border-top: 1px solid #f1f1f1;
  background: #f9f9f9;
  color: #777;
  border-radius: 0 0 5px 5px;
  cursor: pointer;
  position:relative;
  font-style: italic;
}

.vdatetime:first-child{
  border-radius: 10px 10px 0 0 ;
}
.vdatetime:last-child{
  border-radius: 0 0 10px 10px ;
}

</style>




// WEBPACK FOOTER //
// src/components/dashboard/InboxFilter.vue